import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { observer } from 'mobx-react-lite';
import { WelcomeKitPageStore, WelcomeKitPageStoreContext } from 'store/pages/welcome-kit-page/pageStore';
import { useHistory, useParams } from 'react-router-dom';
import FilesTable from 'components/welcome-kit-page/FilesTable';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { PageWrapperStyled } from '../../globalStyles';

const PageContent: React.FC = observer(() => {
  const history = useHistory();

  const returnBack = (): void => {
    history.goBack();
  };

  return (
    <PageWrapperStyled>
      <PageHeader
        title={CARD_DATA.WELCOME_KIT.title}
        subtitle={CARD_DATA.WELCOME_KIT.text}
        onBackButtonClick={returnBack}
        spacing="withActionsBelow"
      />
      <FilesTable />
    </PageWrapperStyled>
  );
});

const WelcomeKitPage: React.FC = () => {
  const { periodId } = useParams<{ periodId: string }>();

  return (
    <ProposalStatusLayout>
      <WelcomeKitPageStoreContext.Provider
        value={useMemo(() => new WelcomeKitPageStore({ enrollmentPeriodId: periodId }), [])}
      >
        <PageContent />
      </WelcomeKitPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default WelcomeKitPage;
